<template>
    <el-dialog
        :before-close="cancel"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :title="`${detail_new.ex_reason ? '新旧任务对比' : '新任务审核'}`"
        :visible.sync="dialogVisible"
        append-to-body
        center
        class="apply-dialog-container"
        top="42px"
        width="1443px">
        <div class="dialog-content flex flex-direction">
            <div class="flex flex-direction bg-white padding-lr padding-bottom radius-bottom">
                <div class="text-df text-black">
                    变更类型：<span class="text-bold">{{ detail_new.is_change ? '任务变更' : detail_new.ex_reason ? '任务信息修改' : '新任务审核'
                    }}</span>
                </div>
                <div v-if="detail_new.ex_reason" class="text-df text-black margin-top-xs">
                    修改说明：{{ detail_new.ex_reason }}
                </div>
                <div class="content-container flex align-center margin-top-sm">
                    <div v-if="detail_new.ex_reason" class="content old flex flex flex-direction padding-tb-xs flex-sub">
                        <div class="flex align-center">
                            <div class="tips text-dg">原任务信息</div>
                            <div class="text-dg text-sm">|<span class="margin-left">{{ pname }}</span></div>
                        </div>
                        <el-divider></el-divider>
                        <div class="flex align-center">
                            <div class="tips text-dg">任务名称</div>
                            <div class="flex flex-direction flex-sub margin-right-sm">
                                <div class="text-dg text-sm padding-tb-sm">{{ detail.name }}</div>
                                <el-divider></el-divider>
                            </div>
                        </div>
                        <div class="flex align-center">
                            <div class="tips text-dg">负责人</div>
                            <div class="flex flex-direction flex-sub margin-right-sm">
                                <div class="text-dg text-sm padding-tb-sm">{{ detail.t_mid }}</div>
                                <el-divider></el-divider>
                            </div>
                        </div>
                        <div class="flex align-center">
                            <div class="tips text-dg">成员</div>
                            <div class="flex flex-direction flex-sub margin-right-sm">
                                <div class="text-dg text-sm padding-tb-sm">{{ detail.join_mid_str }}</div>
                                <el-divider></el-divider>
                            </div>
                        </div>
                        <div class="flex align-center">
                            <div class="tips text-dg">任务结束时间</div>
                            <div class="flex flex-direction flex-sub margin-right-sm">
                                <div class="text-dg text-sm padding-tb-sm">{{ detail.end_time }}</div>
                                <el-divider></el-divider>
                            </div>
                        </div>
                        <div class="flex align-center">
                            <div class="tips text-dg">分值</div>
                            <div class="flex flex-direction flex-sub margin-right-sm">
                                <div class="text-dg text-sm padding-tb-sm">{{ detail.is_outside ? '--' : detail.score }}</div>
                                <el-divider></el-divider>
                            </div>
                        </div>
                        <div class="flex align-center">
                            <div class="tips text-dg">优先级</div>
                            <div class="flex flex-direction flex-sub margin-right-sm">
                                <div class="text-dg text-sm padding-tb-sm">{{ detail.level|level }}</div>
                                <el-divider></el-divider>
                            </div>
                        </div>
                        <div class="flex align-center">
                            <div class="tips text-dg">描述</div>
                            <div class="flex flex-direction flex-sub margin-right-sm">
                                <div class="text-dg text-sm padding-tb-sm">{{ detail.desc || '--' }}</div>
                                <el-divider></el-divider>
                            </div>
                        </div>
                        <div v-if="detail.file.length" class="flex align-center">
                            <div class="tips text-dg">附件</div>
                            <div class="flex flex-direction flex-sub margin-right-sm">
                                <div class="flex-sub flex flex-direction">
                                    <div v-for="(item,index) in detail.file" :key="index" class="flex align-center">
                                        <div :href="item.url" class="file-name flex-sub ovHide text-sm" target="_blank" @click="toFilePreview(item.name,item.url)">
                                            <i class="el-icon-tickets margin-right-xs"></i>{{ item.name }}
                                        </div>
                                    </div>
                                </div>
                                <el-divider></el-divider>
                            </div>
                        </div>
                        <div v-if="detail.folder.length" class="flex align-center">
                            <div class="tips text-dg">需求佐证</div>
                            <div class="flex flex-direction flex-sub margin-right-sm">
                                <div class="flex-sub flex flex-direction">
                                    <div v-for="(item,index) in detail.folder" :key="index" class="flex align-center justify-between">
                                        <div class="flex-sub ovHide cursor">
                                            <i class="iconfont icon-24gf-folderOpen margin-right-xs"></i>{{ item.name }}
                                        </div>
                                    </div>
                                </div>
                                <el-divider></el-divider>
                            </div>
                        </div>
                    </div>
                    <i v-if="detail_new.ex_reason" class="el-icon-d-arrow-right text-xxl text-gray margin-lr-sm"></i>
                    <div class="content flex flex flex-direction padding-tb-xs flex-sub">
                        <div class="flex align-center">
                            <div class="tips text-dg">现任务信息</div>
                            <div class="text-dg text-sm">|<span class="margin-left">{{ pname }}</span></div>
                        </div>
                        <el-divider></el-divider>
                        <div class="flex align-center">
                            <div class="tips text-dg">任务名称</div>
                            <div class="flex flex-direction flex-sub margin-right-sm">
                                <div class="text-dg text-sm padding-tb-sm">{{ detail_new.name }}</div>
                                <el-divider></el-divider>
                            </div>
                        </div>
                        <div class="flex align-center">
                            <div class="tips text-dg">负责人</div>
                            <div class="flex flex-direction flex-sub margin-right-sm">
                                <div class="text-dg text-sm padding-tb-sm">{{ detail_new.t_mid }}</div>
                                <el-divider></el-divider>
                            </div>
                        </div>
                        <div class="flex align-center">
                            <div class="tips text-dg">成员</div>
                            <div class="flex flex-direction flex-sub margin-right-sm">
                                <div class="text-dg text-sm padding-tb-sm">{{ detail_new.join_mid_str }}</div>
                                <el-divider></el-divider>
                            </div>
                        </div>
                        <div class="flex align-center">
                            <div class="tips text-dg">任务结束时间</div>
                            <div class="flex flex-direction flex-sub margin-right-sm">
                                <div class="text-dg text-sm padding-tb-sm">{{ detail_new.end_time }}</div>
                                <el-divider></el-divider>
                            </div>
                        </div>
                        <div class="flex align-center">
                            <div class="tips text-dg">优先级</div>
                            <div class="flex flex-direction flex-sub margin-right-sm">
                                <div class="text-dg text-sm padding-tb-sm">{{ detail_new.level | level }}</div>
                                <el-divider></el-divider>
                            </div>
                        </div>
                        <div class="flex align-center">
                            <div class="tips text-dg">描述</div>
                            <div class="flex flex-direction flex-sub margin-right-sm">
                                <div class="text-dg text-sm padding-tb-sm">{{ detail_new.desc || '--' }}</div>
                                <el-divider></el-divider>
                            </div>
                        </div>
                        <div v-if="detail_new.file.length" class="flex align-center">
                            <div class="tips text-dg">附件</div>
                            <div class="flex flex-direction flex-sub margin-right-sm">
                                <div class="flex-sub flex flex-direction">
                                    <div v-for="(item,index) in detail_new.file" :key="index" class="flex align-center">
                                        <div :href="item.url" class="file-name flex-sub ovHide text-sm" target="_blank" @click="toFilePreview(item.name,item.url)">
                                            <i class="el-icon-tickets margin-right-xs"></i>{{ item.name }}
                                        </div>
                                    </div>
                                </div>
                                <el-divider></el-divider>
                            </div>
                        </div>
                        <div v-if="detail_new.folder.length" class="flex align-center">
                            <div class="tips text-dg">需求佐证</div>
                            <div class="flex flex-direction flex-sub margin-right-sm">
                                <div class="flex-sub flex flex-direction">
                                    <div v-for="(item,index) in detail_new.folder" :key="index" class="flex align-center justify-between">
                                        <div class="flex-sub ovHide cursor">
                                            <i class="iconfont icon-24gf-folderOpen margin-right-xs"></i>{{ item.name }}
                                        </div>
                                    </div>
                                </div>
                                <el-divider></el-divider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-direction bg-white radius margin-top-sm padding-lr padding-tb-sm">
                <div class="text-sm text-black text-bold margin-bottom-xs">审核意见</div>
                <el-input v-model="ruleForm.reason" :autosize="{ minRows: 3, maxRows: 3 }" placeholder="请输入" resize="none"
                          type="textarea">
                </el-input>
                <div class="flex align-center justify-around margin-top-sm">
                    <el-button class="btn max radius" type="danger"  :loading="loading" @click="submitApply(2)">驳回</el-button>
                    <el-button class="btn max radius" type="success" :loading="loading" @click="submitApply(1)">通过</el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import {confirm, slice, TOAST, toast, toFilePreview} from "@/utils/utils";
import {applyExUpdateTask, getExTaskDetail} from "@/api";
import {level_color, levels} from "@/utils/const";

export default {
    name: "TaskApplyDialog",
    components: {},
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        pname: { //项目名称
            type: String,
        },
        sid: { //审核id
            type: Number,
        },
        tid: { //任务id
            type: Number,
        }
    },
    data() {
        return {
            levels: slice(levels),
            detail: '',
            detail_new: '',
            ruleForm: {
                reason: '',
            },
            rules: {
                reason: [
                    {required: true, message: '请输入审核意见', trigger: 'blur'}
                ],
            },
            loading:false
        }
    },
    created() {
        if (this.tid) this.init()
    },
    methods: {
        submitApply(state) {
            if (state === 2){
                if (!this.ruleForm.reason) return  toast('请输入审核意见', TOAST.error)
                this.apply(state)
            } else {
                confirm(`提示`, `你确定通过此任务嘛？`, () => {
                    this.apply(state)
                }, '确认', true)
            }
        },
        async apply(state){
            this.loading = true
            let _data = await applyExUpdateTask(this.tid, this.sid, state, this.ruleForm.reason)
            this.loading = false
            if (_data.status === 200) {
                this.ruleForm.reason = ''
                toast('审核成功', TOAST.success)
                this.$emit('watchState', true)
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        async init() {
            let _data = await getExTaskDetail(this.tid, this.sid)
            _data.data.old.file = _data.data.old.file ? JSON.parse(_data.data.old.file) : []
            _data.data.new.file = _data.data.new.file ? JSON.parse(_data.data.new.file) : []
            this.detail = _data.data.old
            this.detail_new = _data.data.new
        },
        cancel() {
            this.$emit('watchState', false)
        },
        toFilePreview(name,url){
            toFilePreview(name,url)
        }
    },
    filters: {
        level(val) {
            return levels.find(f => Number(f.value) === val).label
        },
        level_color(val) {
            //"status": 0, //项目状态 0未提交审核 1已提交审核 2进行中 3驳回提交
            return level_color(val)
        },
    },
    watch: {
        tid() {
            if (this.tid) this.init()
        }
    }
}
</script>

<style lang="scss" scoped>
.apply-dialog-container {
    .content-container {
        .content {
            border-radius: 10px;
            border: solid 1px #e6e6e6;
            height: 500px;
            overflow-y: auto;

            &::-webkit-scrollbar {
                width: 3px;
                height: 10px;
                background-color: #dae0e6;
            }

            &::-webkit-scrollbar-track {
                border-radius: 10px;
                background-color: #fff;
            }

            &::-webkit-scrollbar-thumb {
                border-radius: 10px;
                background-color: #dae0e6;
            }

            &.old {
                background-color: #fcfcfc;
            }

            .tips {
                width: 146px;
                font-size: 17px;
                font-weight: bold;
                padding: 22px 20px;
                text-align: right;
            }

        }

    }

}

</style>